import React, {Component} from 'react';
import styled from 'styled-components';
import {bindActionCreators} from "redux";
import connect from "react-redux/es/connect/connect";
import {toJS} from "../../to-js";
import * as Actions from "../../actions/actions";
import {mixins} from "../../mixins";

const Row = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 40px;
`;

const Button = styled.button`
  width: ${p => p.theme.sInput}px;
  height: ${p => p.theme.sInput}px;
  border: 1px solid ${p => p.theme.cTheme};
  text-transform: uppercase;
  font-weight: 900;
  color: ${p => p.theme.cTheme};
  background: none;
  margin: 0 5px;
  cursor: pointer;
  ${mixins.ease()};
  &.active, &:hover{
    background-color: ${p => p.theme.cTheme};
    color: ${p => p.theme.cWhite};
  }
`;

const Separator = styled.div`
  display: flex;
  align-items: center;
  span{
    display: block;
    height: 4px;
    width: 4px;
    border-radius: 50%;
    margin: 0 3px;
    background-color: ${p => p.theme.cText};
  }
`;

class Pagination extends Component {

    constructor(props) {
        super(props);

        this.pagesToSow = 3;
        this.pagesToRender = [this.props.catalogPage];
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.pagesToRender = [nextProps.catalogPage];
    }

    recursivelyExpandPages = (leftStart, rightStart) => {
        const newLeft = leftStart - 1;
        const newRight = rightStart + 1;
        const limit = Math.min(this.pagesToSow, this.props.pagesTotal);
        if (this.pagesToRender.length < limit && newLeft >= 0) {
            this.pagesToRender.unshift(newLeft);
        }
        if (this.pagesToRender.length < limit && newRight <= this.props.pagesTotal - 1) {
            this.pagesToRender.push(newRight);
        }
        if (this.pagesToRender.length < limit) {
            this.recursivelyExpandPages(newLeft, newRight);
        }
    };

    getButtons = () => {
        const buttons = [];
        const currentPage = this.props.catalogPage;
        this.recursivelyExpandPages(currentPage, currentPage);
        return this.pagesToRender.map((value, key) => {
            return <Button className={`${this.props.catalogPage === value ? 'active' : ''}`} key={key}
                           onClick={() => this.changePage(value)}>{value + 1}</Button>
        });
    };

    changePage = (page) => {
        if (page >= 0 && page < this.props.pagesTotal) {
            this.props.changeCatalogPage({page: page});
        }
    };

    render() {
        const lastPage = this.props.pagesTotal - 1;
        const buttons = this.getButtons();
        return (
            <div className="container">
                <Row>
                    <button onClick={() => this.changePage(this.props.catalogPage - 1)}>previous</button>
                    {this.pagesToRender[0] > 0 ? <Button className={`${this.props.catalogPage === 0 ? 'active' : ''}`}
                                                         onClick={() => this.changePage(1)}>1</Button> : ''}
                    {this.pagesToRender[0] > 1 ? <Separator><span/><span/><span/></Separator> : ''}
                    {buttons}
                    {this.pagesToRender[this.pagesToRender.length - 1] < lastPage - 1 ?
                        <Separator><span/><span/><span/></Separator> : ''}
                    {this.pagesToRender[this.pagesToRender.length - 1] < lastPage ?
                        <Button className={`${this.props.catalogPage === lastPage ? 'active' : ''}`}
                                onClick={() => this.changePage(lastPage)}>{lastPage + 1}</Button> : ''}
                    <button onClick={() => this.changePage(this.props.catalogPage + 1)}>next</button>
                </Row>
            </div>
        );
    }
}

function mapStateToProps(state) {
    const productsPerPage = state.getIn(['state', 'productsPerPage']);
    const pagesTotal = Math.ceil(state.get('products').size / productsPerPage);
    return {
        pagesTotal: pagesTotal,
        catalogPage: state.getIn(['state', 'catalogPage']),
        productsPerPage: productsPerPage,
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        changeCatalogPage: Actions.changeCatalogPage,
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(toJS(Pagination));